module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.numPanes > 0) ? _c('div', {
    staticClass: "main",
    class: _vm.containerClasses
  }, [_c('nav', {
    attrs: {
      "id": "side-nav"
    }
  }, [_c('ul', {
    staticClass: "menu"
  }, [_vm._l((_vm.panes), function(pane, index) {
    return _c('li', {
      key: ['nav-item', index].join('-'),
      class: {
        'active': index === _vm.currIndex
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.moveToPane(pane, index)
        }
      }
    }, [_vm._v(_vm._s(pane.title))])
  }), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.toggleContactPane($event)
      }
    }
  }, [_c('i', {
    staticClass: "icon-envelope-closed contact"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("Contact")])]), _vm._v(" "), _c('li', {
    staticClass: "toggle-dark",
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.toggleDark($event)
      }
    }
  }, [_c('i', {
    staticClass: "icon",
    class: _vm.toggleIcon
  }), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.toggleLabel))])])], 2), _vm._v(" "), _c('button', {
    staticClass: "menu-toggle icon-list",
    on: {
      "click": function($event) {
        _vm.toggleMenu()
      }
    }
  })]), _vm._v(" "), (_vm.panes[_vm.currIndex].numImages > 0) ? _c('figure', {
    class: _vm.bgClass,
    attrs: {
      "id": "background-picture"
    },
    on: {
      "click": function($event) {
        _vm.flipBg()
      }
    }
  }, [(_vm.prevIndex > -1) ? _c('vue-lazypic', {
    attrs: {
      "imgset": _vm.panes[_vm.prevIndex].image,
      "sizes": _vm.imgSizes,
      "imgClass": "prev-bg"
    }
  }) : _vm._e(), _vm._v(" "), _c('vue-lazypic', {
    attrs: {
      "imgset": _vm.panes[_vm.currIndex].image,
      "sizes": _vm.imgSizes,
      "imgClass": "curr-bg"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "panes-container",
    attrs: {
      "id": "main-content"
    },
    on: {
      "click": function($event) {
        _vm.hideMenu()
      }
    }
  }, [_c('ul', {
    staticClass: "panes"
  }, _vm._l((_vm.panes), function(pane, index) {
    return _c('li', {
      key: ['section', index, pane.id].join('-'),
      staticClass: "pane",
      class: pane.classNames,
      attrs: {
        "id": pane.id,
        "data-top": pane.offsetTop
      }
    }, [_c('article', [_c('h2', [_vm._v(_vm._s(pane.title))]), _vm._v(" "), _c('div', {
      staticClass: "body",
      domProps: {
        "innerHTML": _vm._s(pane.body)
      }
    }), _vm._v(" "), (pane.has_sections) ? _vm._l((pane.sections), function(section, subindex) {
      return _c('div', {
        key: ['subsection', pane.id, subindex].join('-'),
        staticClass: "sub-section",
        class: 'sub-section-' + subindex
      }, [(section.has_title) ? _c('h3', [_vm._v(_vm._s(section.title))]) : _vm._e(), _vm._v(" "), (section.has_body) ? _c('div', {
        staticClass: "sub-body",
        domProps: {
          "innerHTML": _vm._s(section.body)
        }
      }) : _vm._e()])
    }) : _vm._e()], 2)])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "icon-arrow-down",
    attrs: {
      "id": "scroll-down"
    },
    on: {
      "click": function($event) {
        _vm.toNext()
      }
    }
  })]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1bfa9a9d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 95
// module chunks = 1